exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".consortium-page__title[data-v-e106acb6]{margin-bottom:30px}.consortium-page[data-v-e106acb6] .consortium-page__row{cursor:pointer}", ""]);

// exports
